import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { TweenMax, TimelineMax, CSSPlugin, Expo } from 'gsap/all';
import DrawSVGPlugin from '../gsap-bonus/DrawSVGPlugin';
import ScrollMagic from 'scrollmagic';


import '../styles/components/poster.scss';

import play from '../assets/play-button.svg';


export default class Poster extends Component {

    render() {

        return (
          <div className="poster" ref={this.props.myRef}>
            <div className="inner-poster">
              <Link to='/'>
                <div className="overlay" />
              </Link>
              <img src={ this.props.posterImage } alt='' />
              <span className="game-name">{this.props.posterName}</span>
              <span className="game-info">{this.props.posterInfo}</span>
              <div className="play-group">
                <div className="play" onClick={this.props.showVideo}>
                  <img src={ play } alt='play icon' />
                </div>
                <span>Watch Trailer</span>
              </div>
            </div>
          </div>
        );
    }
}
